import { useEffect, useRef, useState } from 'react';

import { cn } from 'lib/helpers/utility';
import useOutsideClick from 'lib/hooks/useOutsideClick';

import Button from 'components/shared/Button/Button';

import DropdownList from './DropdownList';

const InfiniteDropdown = ({
  dropdownClassName = '',
  onChange = () => {},
  items,
  data,
  withButton = false,
  initialOpenState = false,
  parentClassName = '',
  index,
  onWrongFilter = () => {},
  ...rest
}) => {
  const [open, setOpen] = useState(initialOpenState);

  const dropdownRef = useRef();
  const buttonClassName = rest?.className || '';

  useOutsideClick(dropdownRef, () => setOpen(false));

  useEffect(() => {
    if (data && !data?.queryKey && !data?.queryFn) {
      // if the data is not a query key or query fn, remove the filter
      setTimeout(onWrongFilter, 1); // to avoid issues on reloading in same filter view
    }
  }, [data?.queryKey]);

  return (
    <div ref={dropdownRef} className={cn(withButton && 'relative', parentClassName)}>
      {withButton && (
        <Button
          {...rest}
          onClick={() => setOpen((prev) => !prev)}
          className={cn(
            'max-w-48 justify-start  whitespace-nowrap',
            open && 'bg-neutral-100',
            data?.default && 'rounded-r-md',
            buttonClassName
          )}
          textClassName="text-ellipsis overflow-hidden"
        />
      )}
      {open && (
        <DropdownList
          data={data}
          items={items}
          setOpen={setOpen}
          onChange={onChange}
          dropdownClassName={dropdownClassName}
          ref={dropdownRef}
          index={index}
        />
      )}
    </div>
  );
};

export default InfiniteDropdown;
